import { Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';
import Marquee from "react-fast-marquee";
import CarImage from "../../components/images/car-image.png";
import { v4 } from 'uuid';
//import { Data } from '../dashboard/entity';

const useStyles = makeStyles(() => ({
    root: {
        position: "fixed",
        backgroundColor: '#1C396D',
        display: 'flex',
        bottom: '45px',
        zIndex: '10'
    },
    card: {
        marginBottom: '5px',
        margin: '5px',
        maxHeight: "100px",
        height: "auto",
        backgroundColor: '#E2E2E2',
        display: 'flex'
    },
    subCard: {
        margin: '5px',
        width: '100px',
        borderRadius: '4px'
    },
    cardTitle: {
        fontSize: '14px',
        color: '#fff',
        marginLeft: '10px',
        display: 'flex',
        justifyContent: 'center',
        textTransform: 'uppercase'
    },
    subCardText: {
        display: 'flex',
        justifyContent: 'center',
        color: '#fff',
        fontSize: '12px',
    },
}));

const VehicleStatus = (props: any) => {
    const { WorkShopStatusDetails } = props;
    let data =WorkShopStatusDetails ;//technicianData.WorkShopStatusDetails;
    let finalWorkShopStatusDetails = data;
    
    // if(data != null){
    //     let QualityInspectionData :any= data.filter((e:any) => e.Name === "Quality Inspection Awaited");
    //     let isQualityInspectionData :any = data.filter((e:any) => e.Name === "Washing Awaited");
      
    //   if(QualityInspectionData.length !== 0 || isQualityInspectionData.length !== 0){
    //     let WashingAwaited:any[] =[];
    //     let DataofFinal:any[]=[];
          
    //     if(isQualityInspectionData.length !== 0)
    //         WashingAwaited =data.filter((e:any) => e.Name === "Washing Awaited")[0].RegNo;
    //     if(QualityInspectionData.length !== 0)    
    //         DataofFinal =data.filter((e:any) => e.Name === "Quality Inspection Awaited")[0].RegNo;
            
    //     let FinalArray  =[...WashingAwaited,...DataofFinal];   
         
    //     if(isQualityInspectionData.length !== 0){
    //         FinalArray.forEach(element => {
    //             QualityInspectionData[0].RegNo.push(element);
    //         });
    //     }
        
    //    let _workShopStatusDetails =  data.filter((e:any) => e.Name !== "Quality Inspection Awaited" && e.Name !== "Washing Awaited");//WorkShopStatusDetails.filter((ele:any) => ele.Name !== "Quality Inspection Awaited" && ele.Name !== "Washing Awaited" );
    //    finalWorkShopStatusDetails =[..._workShopStatusDetails,...QualityInspectionData];
    //   }
    //   else
    //   finalWorkShopStatusDetails =data;
        
    // } 
    const classes = useStyles();
   
    return (
        <>
            <Grid container className={classes.root}>
                {finalWorkShopStatusDetails?.map((item: any,index:any) => {
                    let nameOfTech;
                    let registrastionNumber:any;
                    let count:any =0 ;
                 if(item.Name === "Quality Inspection Awaited")
                 {
                    nameOfTech =item.Name;
                    count = count+1
                 }
                 else{
                    nameOfTech =item.Name;
                 }
                    return <Grid item xs={3} sm={3} md={3} key={index}>
                        <span className={classes.cardTitle}>
                            {nameOfTech}
                        </span>
                        <div className={classes.card}>
                            <Marquee speed={20}>
                                {item?.RegNo?.map((i: any,index:any) => {
                                    return <div className={classes.subCard} key={index}
                                    style={{
                                        backgroundColor: item.Name == 'Washing Awaited' || item.Name == 'Vehicle Pending' ? '#FF0000' : 'green'
                                    }}>
                                        <Grid container style={{ padding: '2px' }}>
                                            <Grid item xs={12} sm={12} className={classes.subCardText}>
                                                <img src={CarImage} />
                                            </Grid>
                                            <Grid item xs={12} sm={12}>
                                                <span className={classes.subCardText}>
                                                    {i.RegistrationNo}
                                                </span>
                                            </Grid>
                                        </Grid>
                                    </div>
                                })}
                            </Marquee>
                        </div>
                    </Grid>
                })}
            </Grid>
        </>
    )
}

export default VehicleStatus;